import { Grid, Box, LinearProgress } from "@material-ui/core";
import React from "react";

export default function CenteredProgress() {
    return (
        <Grid container justify='center' direction='row' alignItems='center' style={{ minHeight: '75vh' }}>
            <Box flexGrow={1}></Box>
            <Box flexGrow={1} justifyContent='center' >
                <LinearProgress />
            </Box>
            <Box flexGrow={1}></Box>
        </Grid >)
}